// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VKoR","left":"styles_left__l9G4K"};